'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.MarketAnalysis.Toggle', []).controller('MarketAnalysisToggleController', require('./controllers/MarketAnalysisToggleController')).directive('rmMarketAnalysisToggle', require('./directives/MarketAnalysisToggleDirective'));